import { Component, OnInit, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-custom-snackbar-message',
    templateUrl: './custom-snackbar-message.component.html',
    imports: [MatButton, TranslatePipe, ComponentsModule]
})
export class CustomSnackbarMessageComponent implements OnInit {
    private data = inject<{
        message: string;
        action: string;
    }>(MAT_SNACK_BAR_DATA);
    private snackBarRef = inject<MatSnackBarRef<CustomSnackbarMessageComponent>>(MatSnackBarRef);

    public message: string;
    public action: string;

    public ngOnInit(): void {
        this.message = this.data.message || '';
        this.action = this.data.action || '';
    }

    public dismiss(): void {
        this.snackBarRef.dismiss();
    }
}
